import React from "react";

export default function IndonesiaFrame5({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-ind51{fill:#bc0416}.cls-ind52{fill:#e21d27}.cls-ind53{fill:#eae4e4}"
            }
          </style>
        </defs>
        <path
          d="M1699.32 1734.81H300.68c-72.81 0-132.05-59.24-132.05-132.05V204.13c0-72.81 59.24-132.05 132.05-132.05h1398.63c72.81 0 132.05 59.24 132.05 132.05v1398.63c0 72.81-59.24 132.05-132.05 132.05ZM300.68 115.01c-49.14 0-89.12 39.98-89.12 89.12v1398.63c0 49.14 39.98 89.12 89.12 89.12h1398.63c49.14 0 89.12-39.98 89.12-89.12V204.13c0-49.14-39.98-89.12-89.12-89.12H300.68Z"
          className="cls-ind51"
        />
        <path
          d="m407.23 1892.31-57.24-164.26 147.52 15.57-90.28 148.69zM705.81 1921.14l-64.25-161.66 148.06 9.23-83.81 152.43zM1006.04 1927.92l-77.18-155.89 148.31-2.85-71.13 158.74zM1300.94 1918.63l-82.64-153.06 148.11-8.1-65.47 161.16zM1603.99 1887.44l-92.37-147.4 147.28-17.65-54.91 165.05z"
          className="cls-ind52"
        />
        <path
          d="m553.29 1907.11-57.25-164.26 147.53 15.57-90.28 148.69zM856.11 1924.34l-69.51-159.45 148.27 4.36-78.76 155.09zM1150.33 1921.53l-77.18-155.9 148.31-2.84-71.13 158.74zM1460.73 1901.25l-92.37-147.4 147.29-17.66-54.92 165.06z"
          className="cls-ind53"
        />
        <path
          d="M988.51 1775.46c-26.61 0-53.18-.21-79.74-.63-193.23-3.05-388.49-17.27-580.34-42.29l1.8-13.78c191.33 24.94 386.05 39.13 578.76 42.17 272.84 4.3 548.4-13.58 819.01-53.15l2.01 13.75c-245 35.82-494.07 53.92-741.5 53.92Z"
          className="cls-ind51"
        />
        <path
          d="m407.23 274.85-57.24-164.27 147.52 15.58-90.28 148.69zM705.81 303.67l-64.25-161.65 148.06 9.22-83.81 152.43zM1006.04 310.46l-77.18-155.9 148.31-2.84-71.13 158.74zM1300.94 301.17l-82.64-153.06 148.11-8.1-65.47 161.16zM1603.99 269.97l-92.37-147.39 147.28-17.66-54.91 165.05z"
          className="cls-ind52"
        />
        <path
          d="m553.29 289.65-57.25-164.27 147.53 15.58-90.28 148.69zM856.11 306.88 786.6 147.42l148.27 4.36-78.76 155.1zM1150.33 304.06l-77.18-155.89 148.31-2.85-71.13 158.74zM1460.73 283.78l-92.37-147.4 147.29-17.65-54.92 165.05z"
          className="cls-ind53"
        />
        <path
          d="M988.51 158c-26.61 0-53.18-.21-79.74-.63-193.23-3.05-388.49-17.27-580.34-42.28l1.8-13.78c191.33 24.94 386.05 39.13 578.76 42.17 272.84 4.3 548.4-13.58 819.01-53.15l2.01 13.75c-245 35.82-494.06 53.92-741.5 53.92Z"
          className="cls-ind51"
        />
        {children}
      </g>
    </svg>
  );
}
